<template>
	<div>
		<v-dialog v-model="dialog_profit_loss_details" no-click-animation persistent scrollable transition="dialog-bottom-transition">
	      <v-card flat>
	        <v-card-text dialog-card-content style="padding: 0 !important;">
	            <v-layout wrap white-background>
                    <!-- <v-form data-vv-scope="fields" full-width> -->

                        <v-flex xs4 sm4 md4 grey-back pl-3 pr-3 pt-2 pb-2><strong>Particulars</strong></v-flex>
                        <v-flex xs4 sm4 md4 right-align grey-back pl-3 pr-3 pt-2 pb-2><strong>Amount</strong></v-flex>
                        <v-flex xs4 sm4 md4 right-align grey-back pl-3 pr-3 pt-2 pb-2><strong>Balance</strong></v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Opening Stock (-)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.openingAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.openingAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Purchase (-)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.purchaseAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Dr. Note/Purchase Return (+)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.purchaseReturnAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount + data.purchaseReturnAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-2 pb-1>Sale (+)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.saleAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount + data.purchaseReturnAmount + data.saleAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Cr. Note/Sale Return (-)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.saleReturnAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount + data.purchaseReturnAmount + data.saleAmount - data.saleReturnAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Tax Payable (-)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.taxPayableAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount + data.purchaseReturnAmount + data.saleAmount - data.saleReturnAmount - data.taxPayableAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Tax Receivable (+)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.taxReceivableAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount + data.purchaseReturnAmount + data.saleAmount - data.saleReturnAmount - data.taxPayableAmount + data.taxReceivableAmount) }}</v-flex>

                        <v-flex xs4 sm4 md4 pl-3 pr-3 pt-1 pb-1>Closing Stock (+)</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(data.closingAmount) }}</v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1>{{ $root.numberToLocale(- data.openingAmount - data.purchaseAmount + data.purchaseReturnAmount + data.saleAmount - data.saleReturnAmount - data.taxPayableAmount + data.taxReceivableAmount + data.closingAmount) }}</v-flex>

                        <v-flex xs8 sm8 md8 pl-3 pr-3 pt-1 pb-1><strong>{{ data.profitLossAmount >= 0 ? 'Net Profit' : 'Net Loss' }}</strong></v-flex>
                        <v-flex xs4 sm4 md4 right-align pl-3 pr-3 pt-1 pb-1><strong>{{ $root.numberToLocale(data.profitLossAmount) }}</strong></v-flex>

                    <!-- </v-form> -->
              </v-layout>

	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
    props:['data'],
	data(){	
		return{
			dialog_profit_loss_details: false,
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_profit_loss_details = true;
		},
		closeDialogWeb: function () {
			this.dialog_profit_loss_details = false;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/newreports/dialogs/dialog_profit_loss_detail.vue